import {useMemo} from 'react';
import cx from 'classnames';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {ColorUnit} from '~/CreateFabricInvitation/components/ColorUnit/ColorUnit';

import './Colors.sass';

export const Colors = ({
  colors,
  onClick,
  square = false,
  highlight = true,
  className = '',
  height = 32,
  width = 32,
  mobile,
  disabled = false,
  selectedColor,
}) => {
  const isLargishAndUp = useIsLargishAndUp();

  const colorsMemo = useMemo(
    () =>
      colors?.map((color) => (
        <ColorUnit
          color={color}
          key={color}
          onClick={onClick}
          square={square}
          isActive={selectedColor === color && highlight}
          height={height}
          width={width}
          disabled={disabled}
          dataQaId={`step1-textcolor-${color}`}
        />
      )),
    [colors, selectedColor, disabled]
  );

  if (colors.length === 0) return null;
  if (!isLargishAndUp) return colorsMemo;

  return <div className={cx('colors', className, {'colors--mobile': mobile})}>{colorsMemo}</div>;
};
